import React, { Component } from "react";
import Header from "./Header";
import Matspec from "./Matspec";
import Details from "./Details";
import ErrorPage from "./ErrorPage";
import FileUpload from "./FileUpload";
import Modal from "./Modal";
import Splash from "./Splash";
import PreloadingMask from "./PreloadingMask";
import Preloader from "./Preloader";
import BigBucket from "./BigBucket/BigBucket";
import { connect, Provider } from "react-redux";
import store from "../redux/store/index";
import blankImage from "../media/blank.png";
import Placeholder from "../media/placeholder.png";
import { devMode, imageUrlPath, urlPath } from "./Settings";
import { getAuthHeader, setAuthHeader, setUser } from "../utils/security";
import { Button, Checkbox, Dropdown, Icon, Menu, Tooltip } from "antd";
import { admaterialUpdateHelper, highlightMaterial, Notification, } from "./Helpers";
import "url-search-params-polyfill";
import "antd/dist/antd.css";
import "../Styles.css";
import { setFieldsToSave, setMatspecsToSubmit } from '../redux/actions'

const mapDispatchToProps = dispatch => {
    return {
        setFieldsToSave: key => dispatch(setFieldsToSave(key)),
        setMatspecsToSubmit: data => dispatch(setMatspecsToSubmit(data)),

    };
};

const mapStateToProps = state => {
    return {
        fieldsToSave: state.fieldsToSave,
        matspecsToSubmit: state.matspecsToSubmit
    };
};

const url = new URL(window.location.href);
const modeParam = url.searchParams.get("mode");
const nativeDevParam = url.searchParams.get("isNative") === "true" || false;

/* eslint no-unused-expressions: 0 */
class App extends Component {
    constructor(props) {
        super(props);
        //console.clear();
        /* console.log(
      "%c*** Initializing application " +
        (devMode ? "in devMode " : "") +
        "***",
      "color: #3498db; font-weight: bold"
    ); */

        var urlParams = new URLSearchParams(window.location.search);
        const matspecNameParam = urlParams.get("matspecname");
        const modeParam = urlParams.get("mode");
        const nosplashParam = urlParams.get("nosplash"); /* used in UI tests */
        let lang = this.getLangOrDefault(urlParams.get("language"));
        let defaultTabSelected = sessionStorage.getItem("filterTabSelected");
        defaultTabSelected = defaultTabSelected ? defaultTabSelected : "all";
        this.state = {
            bookingLoaded: true,
            creativeTypes: [],
            currentFileUrl: null,
            currentTabKey: defaultTabSelected,
            detailsVisible: false,
            checkedMatspecsArray: [],
            editableView: false,
            bigpreviewMode: false,
            fieldConfig: null,
            language: null, // TODO: confusing name -> rename it to fieldTranslations in all components
            languageCode: lang,
            loadDetails: false,
            loadHeader: false,
            loadSplash: false,
            matspecNameParam: matspecNameParam,
            modeParam: modeParam,
            orderNumber: "Order no",
            preflightReport: null,
            preloader: false,
            preloadingMask: true,
            specId: null,
            splashVisible:
                modeParam !== "details" &&
                (!localStorage.getItem("splash") && this.props.config["web.campaign.enableSplashScreen"]),
            text: "sample text",
            translations: null,
            upload: true,
            visible: false,
            showArchived: "show-archived-false",
            splashLoaded: false,
        };
        this.uploadFinished = this.uploadFinished.bind(this);
        this.submitting = this.submitting.bind(this);
    }

    getLangOrDefault(lang) {
        const storedLanguage = localStorage.getItem("language");
        if (storedLanguage) {
            //console.log('storedLanguage: ' + storedLanguage);
            lang = storedLanguage;
        }
        return lang ? lang : "en";
    }
    setLang = (langCode) => {
        let lang = this.getLangOrDefault(langCode);
        this.setState({ languageCode: lang });
        this.fetchTranslations(lang);
    };
    unsubmittedChanges = (val) =>
        this.setState({ unsubmittedChangesValue: val });
    fetchTranslations(langCode) {
        fetch(urlPath + "/api/noauth/fieldtranslations?type=Job" + (langCode ? "&language=" + langCode : ""))
            .then((response) => response.json())
            .then((data) =>
                this.setState({
                    fieldTranslations: data.data,
                    language: data.data,
                }))
            .catch((e) => console.error("Cannot load field translations", e));
        fetch(urlPath + "/api/noauth/translations" + (langCode ? "?language=" + langCode : ""))
            .then((response) => response.json())
            .then((data) => this.setState({ translations: data.data }))
            .catch((e) => console.error("Cannot load translations", e));
    }

    showModal = () => this.setState({ visible: true });

    uploadFinished(report) {
        console.log("report", report);
        //if (report.length > 1) window.location.reload();
        const { firstMatspecId, singleAd } = this.state;
        const newAdmaterialId =
            report[0] && report[0].admaterial
                ? report[0].admaterial.id
                : undefined;
        this.setState({
            preflightReport: report,
            detailsVisible: false,
            preloader: false,
        });
        if (singleAd)
            setTimeout(() => this.previewClick(true, newAdmaterialId, firstMatspecId), 500);
        //console.log("newAdmaterialId", newAdmaterialId);
        setTimeout(() => {
            const dropzone = document.getElementById("dropzone-AdMaterial." + newAdmaterialId);
            if (dropzone) dropzone.classList.remove("d-none");
        }, 100);
    }

    handleOk = (e) => {
        this.saveFields()
        console.log("event", e);
        this.setState({
            visible: false,
            upload: false,
            detailsVisible: false,
            preloader: false,
        });
    };
    submitting() {
        this.setState({
            preflightReport: null,
        });
    }
    handleCancel = (e) => {
        //console.log("closing modal", e);
        //this.unsubmittedChanges(false);
        this.saveFields()
        const approveAdmaterialId = this.state.approveAdmaterialId;
        highlightMaterial(approveAdmaterialId);
        this.setState(
            {
                detailsVisible: false,
                visible: false,
                highlightedMaterial: approveAdmaterialId,
            }
            //this.setScrollPosition(window)
        );
    };

    handleAdMatRemoval = async () => {
        const { currentMatSpecId, matspec } = this.state;
        const { matspecs } = matspec;
        const selectedMatSpec = matspecs.find(({ id }) => id === currentMatSpecId);
        if (selectedMatSpec) {
            const hasEmptyCreative = selectedMatSpec.admaterial.filter(
                (_) => _.matfilecount === 0
            ).length !== 0;
            if (hasEmptyCreative) {
                let targetUrl =
                    urlPath +
                    '/api/admaterialdiscard?matspec=' +
                    currentMatSpecId +
                    '&admaterial=' +
                    this.state.approveAdmaterialId +
                    '&timezone=' +
                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                await fetch(targetUrl, {
                    method: 'POST',
                    credentials: 'include',
                    headers: getAuthHeader(),
                });
            }
        }
        this.handleCancel();
    }

    handleResubmit = () => {
        this.saveFields()
        this.setState({ detailsVisible: false });
        /*for(let i = 0; i < order.matspecs.length; i++) {
			for(let j = 0; j < order.matspecs[i].admaterial.length; j++) {
				if (order.matspecs[i].admaterial[j].id === this.state.approveAdmaterialId) {
					const ID = - Math.floor(Math.random() * 1000000) + 1;
                    initialStatus = order.matspecs[i].admaterial[j].initialStatus;
					order.matspecs[i].admaterial[j] = {
						id: ID,
						status: {
							code: 522,
							text: this.state.statuses && this.state.statuses.data[522] && this.state.statuses.data[522].text? this.state.statuses.data[522].text: "522",
							color: this.state.statuses && this.state.statuses.data[522] && this.state.statuses.data[522].color? this.state.statuses.data[522].color: "0xFFFFFF"
						},
						preview: {url: ''},
						original: {
							preview: {url: ''}
						}
					};
					setTimeout(function() {
						const classList = document.getElementById("dropzone-AdMaterial." + ID).classList;
						if (classList.contains('valid-true'))
							classList.remove('valid-false');
						classList.remove('review-true');
                        //window.location.reload();
					}, 100)
				}
			}
		}
        setTimeout(() => highlightMaterial(this.state.approveAdmaterialId) , 4500)
		console.log('matspecs', this.state.matspec.matspecs);
		//this.loadMatspec(order); WHY THIS FUNCTION HAS BEEN REMOVED?
        */
    };

    checkReferrer = (data) => {
        if (window.location.hostname === document.referrer.split("/")[2]) {
            document.title = data.ad.orderno;
            document.head
                .getElementsByTagName("title")[0]
                .setAttribute("readonly", "true");
            /*console.log(
        "updating title with ad",
        document.head.getElementsByTagName("title")[0],
        window.top
      );*/
            if (window.top.IX && window.top.IX.updateTitle)
                window.top.IX.updateTitle(window.location.href);
            else console.warn("Cannot find method to update title", window.top);
        } else document.title += " " + data.ad.orderno;
    };

    processEmptyBooking = (data) => {
        console.log("processing empty booking");
        //console.log(data);
        document.body.classList.add("empty-booking");
        if (data.AuthorizationToken)
            setAuthHeader({
                Authorization: "Basic " + data.AuthorizationToken,
            });
        fetch(
            urlPath +
            "/api/customframe?key=campaign_info&matspec=" +
            data.currentMaterialSpecification +
            "&language=" +
            this.state.languageCode +
            "&timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            { credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) => this.setState({ campaignInfoFrame: data.url }))
            .catch((e) =>
                console.error("Cannot load campaign custom frame", e)
            );

        fetch(
            urlPath +
            "/api/customframe?key=header&matspec=" +
            data.currentMaterialSpecification +
            "&language=" +
            this.state.languageCode +
            "&timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            { credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) => {
                this.setState({ headerFrameUrl: data.url });
            })
            .catch((e) => console.error("Cannot load header custom frame", e));
        this.setState({
            loadHeader: true,
        });
        this.hidePreloadingMask();
    };

    updateBooking = (data) => {
        this.setState({ matspec: data });
    };

    loadBooking = (data) => {
        console.log("loadBooking: data:", data);
        //from Matspec module
        //console.log("***LOADING BOOKING");
        if (data.matspecs.length < 1) {
            //console.log("empty matspecs booking");
            this.processEmptyBooking(data);
            return;
        }
        this.checkReferrer(data);
        const singleAd =
            data.matspecs.length === 1 &&
            data.matspecs[0].admaterial.length === 1;
        /*console.log(
      "This is a" +
        (singleAd ? " single" : " multiple") +
        (this.state.tabbedView ? " tabbed" : "") +
        " ad campaign"
    );*/
        /* data.matspecs.map(matspec => {
      matspec['productionmanuscript2'] = '\u003cp style\u003d\"margin-left: 40px\"\u003e\u003cul\u003e\u003cli\u003eHet Nieuwsblad Nationaal + Tablet\u003cul\u003e\u003cli\u003eHet Nieuwsblad Nationaal 10/08/2019\u003c/li\u003e\u003cli\u003eHet Nieuwsblad Nationaal digitaal ochtend 10/08/2019\u003c/li\u003e\u003c/ul\u003e\u003c/li\u003e\u003c/ul\u003e\u003c/p\u003e'
    }) THIS IS FOR TESTING HTML RENDERING INSIDE A TABLE CELL */
        if (this.state.tabbedView) {
            document.title = data.ad.orderno;
            document.head
                .getElementsByTagName("title")[0]
                .setAttribute("readonly", "true");
            /*console.log(
        "updating title with matspec",
        document.head.getElementsByTagName("title")[0]
      );*/
            if (window.top.IX && window.top.IX.updateTitle)
                window.top.IX.updateTitle(window.location.href);
            else console.warn("Cannot find method to update title", window.top);
        } else {
            document.title += " " + data.currentMaterialSpecification;
        }
        this.setState({
            loadBookingData: data,
            currentMaterialSpecification: data.currentMaterialSpecification,
            matspec: data,
            specId: data.currentMaterialSpecification,
            loadHeader: true,
            loadSplash: true,
            loadDetails: true,
            firstMatspecId: data.matspecs[0].id,
            firstAdmaterialId: data.matspecs[0].admaterial[0].id,
            singleAd: singleAd,
            orderno: data.ad.orderno,
        });
        if (modeParam === "details") {
            let tmpProductionAd = null;
            let tmpStatusCode = null;
            let tmpAdmaterial = null;
            for (let i = 0; i < data.matspecs.length; i++) {
                const currentSpec = data.matspecs[i];
                if (currentSpec.id === data.currentMaterialSpecification) {
                    tmpProductionAd = currentSpec.productionad;
                    tmpStatusCode = currentSpec.status.code;
                    tmpAdmaterial = !data.currentAdMaterial
                        ? currentSpec.admaterial[0].id
                        : parseInt(data.currentAdMaterial, 10);
                    if (currentSpec.printed)
                        tmpAdmaterial = currentSpec.admaterial[0].id;
                }
            }
            if (!data.currentAdMaterial) {
                this.previewClick(
                    true,
                    tmpAdmaterial,
                    data.currentMaterialSpecification,
                    "[]",
                    tmpProductionAd,
                    tmpStatusCode
                );
            } else {
                this.previewClick(
                    true,
                    tmpAdmaterial,
                    data.currentMaterialSpecification,
                    null,
                    tmpProductionAd,
                    tmpStatusCode
                );
            }
        }
        if (data.user.rol_enum !== "ADMIN")
            fetch(
                urlPath +
                "/api/saveaudit?action=CAMPAIGN_OPENED&matspec=" +
                data.currentMaterialSpecification,
                {
                    method: "POST",
                    credentials: "include",
                    headers: getAuthHeader(),
                }
            )
                .then((response) => {
                    console.log("Submitted audit", response.text());
                })
                .catch((e) => console.error("Cannot submit audit", e));

        fetch(
            urlPath +
            "/api/customframe?key=campaign_info&matspec=" +
            data.matspecs[0].id +
            "&language=" +
            this.state.languageCode +
            "&timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            { credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) => this.setState({ campaignInfoFrame: data.url }))
            .catch((e) =>
                console.error("Cannot load campaign custom frame", e)
            );

        fetch(
            urlPath +
            "/api/customframe?key=header&matspec=" +
            data.matspecs[0].id +
            "&language=" +
            this.state.languageCode +
            "&timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            { credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) => this.setState({ headerFrameUrl: data.url }))
            .catch((e) => console.error("Cannot load header custom frame", e));
        if (this.state.splashVisible) {
            this.loadSplashFrame(data.matspecs[0].id, this.state.languageCode);
            this.setState({ splashLoaded: true });
        }
        this.checkCreativeTypes(data);
    };

    loadSplashFrame = (matspecId, languageCode) => {
        const currentUrl = new URL(window.location.href);
        let mode = currentUrl.searchParams.get("mode");
        fetch(urlPath + "/api/customframe?key=splash" + (mode ? "_" + mode : "") + "&matspec=" + matspecId + "&language=" + languageCode + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
            { credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) => this.setState({ splashFrame: data.url }))
            .catch((e) => console.error("Cannot load Splash custom frame", e));
    };

    checkCreativeTypes = (data) => {
        let matspecs = data.matspecs;
        let creativeTypes = [];
        for (let i = 0; i < matspecs.length; i++) {
            const currentMatspec = matspecs[i];
            if (currentMatspec.creativetype)
                creativeTypes = creativeTypes.concat(currentMatspec.creativetype.toLowerCase());
        }
        /* creativeTypes = creativeTypes.reduce((unique, item) =>
      unique.includes(item) ? unique : [...unique, item]
    ); */
        const uniqueSet = new Set(creativeTypes);
        creativeTypes = [...uniqueSet];
        this.setState({ creativeTypes });
    };
    showOrHideByCreativeType = (type) => {
        let elems = document.getElementsByClassName("creative-type");
        for (var i = 0; i < elems.length; i++) {
            if (type === "all" || elems[i].classList.contains("creative-type-" + type))
                elems[i].removeAttribute("style");
            else elems[i].setAttribute("style", "display: none");
        }
    };
    handleTabFilterClick = (e) => {
        const checkboxGroup = document.querySelectorAll(".group-checkbox");
        for (let i = 0; i < checkboxGroup.length; i++) {
            const curr = checkboxGroup[i];
            if (curr.querySelector(".ant-checkbox-checked"))
                curr.querySelector(".ant-checkbox-checked input").click();
        }

        const type = e.key;
        sessionStorage.setItem("filterTabSelected", type);
        console.log(type);
        this.showOrHideByCreativeType(type);
        this.setState({ currentTabKey: type });
        //this.handleMultiChecked([])
    };
    handleLangCode = (langCode) => {
        langCode = langCode.toLowerCase();
        this.setLang(langCode);
    };
    clickHelp = () => {
        const { splashLoaded, loadBookingData } = this.state;
        if (!splashLoaded) {
            this.loadSplashFrame(
                loadBookingData.matspecs[0].id,
                this.state.languageCode
            );
            this.setState({ splashLoaded: true });
        }
        this.setState({ splashVisible: true });
    };
    closeSplash = () => {
        const { translations } = this.state;
        Notification(
            translations.help,
            translations.splashHint,
            "topRight",
            translations.ok
        );
        this.setState({ splashVisible: false });
    };
    closeModal = () => {
        this.handleCancel();
    };
    /* ASSET AS VISUAL */
    assetToMaterial = (admaterial, admaterialid, matspecid) => {
        const matspecs = this.state.matspec.matspecs;
        let previewClickAction = false;
        for (let i = 0; i < matspecs.length; i++) {
            if (matspecs[i].id === matspecid) {
                matspecs[i].admaterial.push(admaterial);
                for (let j = 0; j < matspecs[i].admaterial.length; j++) {
                    if (matspecs[i].admaterial[j].id < 0) {
                        matspecs[i].admaterial.splice(j, 1);
                        break;
                    }
                }
                previewClickAction = true;
            }
        }
        if (previewClickAction) {
            this.previewClick(true, admaterialid, matspecid, [], true);
        }
    };

    getPreviewUrl(adm) {
        return adm.bigpreview && adm.bigpreview.url
            ? imageUrlPath + adm.bigpreview.url
            : adm.original &&
                adm.original[0] &&
                adm.original[0].url &&
                !adm.original[0].url.endsWith("html")
                ? imageUrlPath + adm.original[0].url
                : Placeholder;
    }
    getMultiplePreviews(adm) {
        const admToString = JSON.stringify(adm);
        const bigpreviewCount = (admToString.match(/bigpreview/g) || []).length;
        //console.log("Number of bigpreview: " + bigpreviewCount);
        const bigpreviewArray = [];
        for (let i = 0; i < bigpreviewCount; i++) {
            if (i === 0)
                bigpreviewArray.push(imageUrlPath + adm["bigpreview"].url);
            else
                bigpreviewArray.push(
                    imageUrlPath + adm["bigpreview" + (i + 1)].url
                );
        }
        this.setState({ pageCountMax: bigpreviewArray.length });
        //console.log(bigpreviewArray);
        return bigpreviewArray;
    }
    getScrollPosition = (element) => {
        const scrollX = element.scrollX;
        const scrollY = element.scrollY;
        this.setState({ scrollX: scrollX, scrollY: scrollY });
    };
    setScrollPosition = (element) => {
        const scrollX = this.state.scrollX;
        const scrollY = this.state.scrollY;
        element.scrollTo(scrollX, scrollY);
    };
    previewClick = (
        editableView,
        admaterialId,
        matspecId,
        newAssetIds,
        productionad,
        status,
        showVisual,
        showProductionAdButtons
    ) => {
        const values = [
            editableView,
            admaterialId,
            matspecId,
            newAssetIds,
            productionad,
            status,
            showVisual,
        ];
        let currentMatSpecIdInitialized = false;
        this.setState({ pageCount: 0, openedMatspec: matspecId });
        if (!this.state.internal && editableView)
            fetch(
                urlPath +
                "/api/saveaudit?action=DETAILS_OPENED&matspec=" +
                matspecId +
                (admaterialId ? "&admaterial=" + admaterialId : ""),
                {
                    method: "POST",
                    credentials: "include",
                    headers: getAuthHeader(),
                }
            )
                .then((response) => {
                    console.log("Submitted audit", response.text());
                })
                .catch((e) => console.error("Cannot submit audit", e));

        /*console.log(
      "previewClick(" +
        editableView +
        ", " +
        admaterialId +
        ", " +
        matspecId +
        ", " +
        newAssetIds +
        ", " +
        productionad +
        ")"
    );*/
        if (newAssetIds)
            this.setState({
                editableView: editableView,
                newAssetIds: newAssetIds,
                assetUpload: true,
                assetView: true,
            });
        if (productionad)
            this.setState({
                editableView: editableView,
                newAssetIds: newAssetIds,
                assetUpload: true,
                assetView: true,
            });
        if (!productionad)
            this.setState({
                editableView: editableView,
                newAssetIds: newAssetIds,
                assetUpload: false,
                assetView: false,
            });
        if (!newAssetIds)
            this.setState({
                editableView: editableView,
                newAssetIds: newAssetIds,
                assetUpload: false,
                assetView: false,
            });
        this.getScrollPosition(window);
        if (status) {
            this.setState({
                currentStatusCode: status,
            });
        }

        /*TEMP SOLUTION FOR VIDEO CONTROLS */
        for (let i = 0; i < this.state.matspec.matspecs.length; i++) {
            const currentMatspec = this.state.matspec.matspecs[i];
            for (let j = 0; j < currentMatspec.admaterial.length; j++) {
                const currentAd = currentMatspec.admaterial[j];
                if (currentAd.id === admaterialId) {
                    const showVideoControls =
                        currentAd.format === "mp4" ||
                        currentAd.format === "MP4" ||
                        currentAd.format === "mpg" ||
                        currentAd.format === "MPG" ||
                        currentAd.format === "mpeg" ||
                        currentAd.format === "MPEG" ||
                        currentAd.format === "html" ||
                        currentAd.format === "HTML" ||
                        currentAd.format === "webm" ||
                        currentAd.format === "WEBM" ||
                        currentAd.format === "xml" ||
                        currentAd.format === "XML";
                    const allowDownload = currentAd.actions.DOWNLOAD;
                    const proofLink = currentAd.prooflink;
                    const hasMetadata =
                        currentAd.original &&
                        currentAd.original[0] &&
                        currentAd.original[0].htmlattributes &&
                        currentAd.original[0].htmlattributes.metadata;
                    const hasClickTag =
                        currentAd.original &&
                        currentAd.original[0] &&
                        currentAd.original[0].htmlattributes &&
                        currentAd.original[0].htmlattributes.hasclicktag;
                    let loadIframe = true;
                    if (hasMetadata) {
                        loadIframe = !currentAd.original[0].htmlattributes.metadata.includes(
                            "bonzai"
                        );
                    }
                    this.setState({
                        hasClickTag,
                        showVideoControls,
                        allowDownload,
                        currentMatspecId: currentMatspec.id,
                        proofLink,
                        showProductionAdButtons,
                        loadIframe,
                    });
                }
            }
        }

        /* END TEMP SOLUTION FOR VIDEO CONTROLS */
        if (productionad) {
            if (status === 518 || status === 517)
                this.setState({ defaultActiveTabReport: "5" });
            else this.setState({ defaultActiveTabReport: "7" });
            let hasMaterial = false;
            let hasVisual = false;
            let materialPreview = null;
            let bigpreviewArray = null;
            let partyTagAd = null;
            let matspecname = null;
            let originalUrl = null;
            const matspecs = this.state.matspec.matspecs;

            if (matspecId) {
                if (admaterialId) {
                    for (let i = 0; i < matspecs.length; i++) {
                        if (matspecId === matspecs[i].id)
                            this.setState({ printed: matspecs[i].printed });
                        for (
                            let j = 0;
                            j < matspecs[i].admaterial.length;
                            j++
                        ) {
                            const currentAd = matspecs[i].admaterial[j];
                            if (currentAd.id === admaterialId) {
                                matspecname = matspecs[i].name;
                                if (currentAd.inputfilename) {
                                    partyTagAd = currentAd.inputfilename.startsWith(
                                        "thirdparty"
                                    );
                                }
                                if (
                                    currentAd.original &&
                                    currentAd.original[0] &&
                                    currentAd.original[0].url
                                ) {
                                    hasMaterial = true;
                                    originalUrl = currentAd.original[0].url;
                                    if (currentAd.bigpreview && !showVisual) {
                                        bigpreviewArray = this.getMultiplePreviews(
                                            currentAd
                                        );
                                        materialPreview = originalUrl.endsWith(
                                            ".gif"
                                        )
                                            ? originalUrl
                                            : currentAd.bigpreview.url;
                                    }
                                    if (!currentAd.bigpreview && !showVisual)
                                        materialPreview =
                                            currentAd.original[0].url;
                                } else {
                                    hasMaterial = false;
                                }
                            }
                        }
                    }
                    this.setState({
                        hasVisual: hasVisual,
                        hasMaterial: hasMaterial,
                        productionad: productionad,
                        approveAdmaterialId: admaterialId,
                    });
                }
				// CWE: added feature to show visual when status is PICKED UP (578)
                if (!hasMaterial || showVisual || status === 578) {
                    this.setState({ assetView: true });
                } else {
                    this.setState({ assetView: false });
                    //this.setState({defaultActiveTabReport:'1'});
                }
                fetch(
                    urlPath +
                    "/api/loadassets?matspec=" +
                    matspecId +
                    "&timezone=" +
                    Intl.DateTimeFormat().resolvedOptions().timeZone,
                    {
                        credentials: "include",
                        headers: getAuthHeader(),
                    }
                )
                    .then((response) => response.json())
                    .then((data) => {
                        const assetData = {};
                        assetData.productionad = productionad;
                        assetData.hasMaterial = hasMaterial;
                        assetData.partyTagAd = partyTagAd;
                        assetData.originalUrl = originalUrl;
                        assetData.matspecname = matspecname;
                        for (let i = 0; i < data.length; i++) {
                            if (data[i]["type_enum"] === "VISUAL") {
                                //const previewImage = document.getElementById('previewImage');
                                if (!hasMaterial || showVisual) {
                                    const filesWithPreview =
                                        "jpg jpeg png tiff gif psd pdf";
                                    const hasPreview =
                                        filesWithPreview.indexOf(
                                            data[i].originalfile.format
                                        ) != -1;

                                    if (!data[i].bigpreview && hasPreview) {
                                        this.previewClick(...values);
                                    } else if (
                                        !data[i].bigpreview &&
                                        !hasPreview
                                    ) {
                                        assetData.previewUrl = blankImage;
                                        assetData.urlFile =
                                            data[i].originalfile.url;
                                        assetData.fileName = data[i].name;
                                    } else {
                                        assetData.previewUrl =
                                            imageUrlPath +
                                            data[i].bigpreview.url;
                                    }
                                }

                                hasVisual = true;
                                assetData.hasVisual = hasVisual;
                                this.setState({
                                    hasVisual: true,
                                    assetVisualId: data[i].id,
                                });
                            }
                        }

                        if (hasMaterial && !showVisual) {
                            assetData.previewUrl =
                                imageUrlPath + materialPreview;
                            assetData.bigpreviewArray = bigpreviewArray;
                            fetch(
                                urlPath +
                                "/api/loadpreflightreport?admaterial=" +
                                admaterialId +
                                "&language=" +
                                this.state.languageCode,
                                {
                                    credentials: "include",
                                    headers: getAuthHeader(),
                                }
                            )
                                .then((preflightResponse) =>
                                    preflightResponse.json()
                                )
                                .then((preflightData) => {
                                    assetData.xmllogUrl =
                                        preflightData.xmllogUrl;

                                    this.setState({
                                        preflightReport: assetData,
                                        detailsVisible: true,
                                        approveAdmaterialId: admaterialId,
                                    });
                                    currentMatSpecIdInitialized = true;
                                })
                                .catch((e) =>
                                    console.error("Cannot load report", e)
                                );
                        } else {
                            this.setState({
                                preflightReport: assetData,
                                detailsVisible: true,
                                approveAdmaterialId: admaterialId,
                            });
                            currentMatSpecIdInitialized = true;
                        }
                    })
                    .catch((e) => console.error("Cannot load assets", e));
            } else console.error("App: Cannot load assets without matspecId");
        }

        const matspecs = this.state.matspec.matspecs;

        this.setState({
            preflightReport: null,
            previewClickStatusCode: status,
        });
        if (!productionad) {
            if (status === 518 || status === 517) {
                this.setState({ defaultActiveTabReport: "5" });
            } else {
                if (admaterialId > 0)
                    this.setState({ defaultActiveTabReport: "1" });
                else this.setState({ defaultActiveTabReport: "2" });
            }
            for (let i = 0; i < matspecs.length; i++) {
                if (matspecs[i].id === matspecId)
                    this.setState({ printed: matspecs[i].printed });
                for (let j = 0; j < matspecs[i].admaterial.length; j++) {
                    if (matspecs[i].admaterial[j].id === admaterialId) {
                        const adm = matspecs[i].admaterial[j];
                        const data = {};
                        data.productionad = matspecs[i].productionad;
                        data.previewUrl = this.getPreviewUrl(adm);
                        data.bigpreviewArray = this.getMultiplePreviews(adm);
                        if (adm.inputfilename)
                            data.partyTagAd = adm.inputfilename.startsWith(
                                "thirdparty"
                            );
                        if (
                            data.previewUrl &&
                            !data.previewUrl.endsWith(".svg") &&
                            !data.previewUrl.includes(".spinner")
                        ) {
                            data.files = [
                                {
                                    fileUrl: adm.inputfilename,
                                    format: adm.format,
                                },
                            ];
                            data.modificationDate = adm.modificationdate;

                            const previewImage = document.getElementById(
                                "previewImage"
                            );
                            if (previewImage) {
                                let src = previewImage.getAttribute("src");
                                let newSrc = data.previewUrl;
                                if (src !== newSrc) {
                                    previewImage.setAttribute("src", newSrc);
                                }
                            }
                            this.setState({
                                preflightReport: JSON.stringify(data),
                                detailsVisible: true,
                                currentMatSpecId: matspecs[i].id,
                                approveAdmaterialId: admaterialId,
                            });
                            currentMatSpecIdInitialized = true;
                        }
                        const statusCode = adm.status.code;
                        if (statusCode === 536)
                            this.setState({ defaultActiveTabReport: "4" });
                        else if (statusCode === 518 || statusCode === 517)
                            this.setState({ defaultActiveTabReport: "5" });
                        break;
                    }
                }
            }
        }
        if (!currentMatSpecIdInitialized) {
            this.setState({
                currentMatSpecId: matspecId,
                detailsVisible: true,
            });
        }

        if (admaterialId && !productionad)
            fetch(
                urlPath +
                "/api/loadpreflightreport?admaterial=" +
                admaterialId +
                "&language=" +
                this.state.languageCode,
                { credentials: "include", headers: getAuthHeader() }
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.fatalError)
                        data.fatalError =
                            "Corrupt creative! The provided creative cannot be processed.";
                    const matspecs = this.state.matspec.matspecs;
                    for (let i = 0; i < matspecs.length; i++) {
                        for (let j = 0; j < matspecs[i].admaterial.length; j++)
                            if (matspecs[i].admaterial[j].id === admaterialId) {
                                const adm = matspecs[i].admaterial[j];
                                if (
                                    adm.original &&
                                    adm.original[0] &&
                                    matspecs[i].admaterial[j].original[0].url
                                ) {
                                    this.setState({ hasMaterial: true });
                                } else {
                                    this.setState({ hasMaterial: false });
                                }
                                if (adm.bigpreview)
                                    data.previewUrl = this.getPreviewUrl(adm);
                                if (adm.bigpreview)
                                    data.bigpreviewArray = this.getMultiplePreviews(
                                        adm
                                    );
                                if (adm.original) data.files = adm.original;
                                if (adm.original) data.size = adm.original.size;
                                if (adm.original && adm.original[0])
                                    data.originalUrl = adm.original[0].url;
                                if (
                                    adm.original &&
                                    adm.original[0] &&
                                    adm.original[0].url.endsWith(".xml") &&
                                    adm.processed
                                ) {
                                    data.originalUrl = adm.processed.url;
                                }
                                if (adm.destinationfile)
                                    data.destinationfile = adm.destinationfile;
                                if (adm.modificationdate)
                                    data.modificationDate =
                                        adm.modificationdate;
                                if (adm.inputfilename)
                                    data.partyTagAd = adm.inputfilename.startsWith(
                                        "thirdparty"
                                    );
                                data.matspecid = matspecs[i].id;
                                data.matspecname = matspecs[i].name;
                                data.admaterialid = admaterialId;
                                data.visualassetid = matspecs[i].visualassetid;
                                data.productionad = matspecs[i].productionad;
                                if (data.visualassetid !== 0) {
                                    data.visualassetid =
                                        matspecs[i].visualassetid;
                                    this.setState({ hasVisual: true });
                                } else {
                                    this.setState({ hasVisual: false });
                                }
                                this.setState({
                                    approveAdmaterialId: admaterialId,
                                });
                                this.setState({
                                    preflightReport: JSON.stringify(data),
                                });
                                break;
                            }
                    }
                    if (data && data.originalUrl) {
                        let elem = document.getElementById("animation-switch");
                        if (elem) {
                            if (
                                data.originalUrl.endsWith(".pdf") ||
                                data.originalUrl.endsWith(".eps")
                            )
                                document
                                    .getElementById("animation-switch")
                                    .classList.add("hidden");
                            else
                                document
                                    .getElementById("animation-switch")
                                    .classList.remove("hidden");
                        }
                    }
                    return data;
                })
                .catch((e) => console.error("Cannot load report", e));

        if (admaterialId > 0)
            fetch(
                urlPath +
                "/api/loadchangesbuttons?matspec=" +
                matspecId +
                (admaterialId ? "&admaterial=" + admaterialId : ""),
                { credentials: "include", headers: getAuthHeader() }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState({ changesButtons: data });
                })
                .catch((e) => console.error("Cannot load report", e));
        else this.setState({ changesButtons: [] });
        /*if (!admaterialId) {
			this.setState({
				detailsVisible: true,
				matspecId: matspecId
			});
		}*/
    };
    handleBigPreviewMode = (e) => {
        const { bigpreviewMode } = this.state;
        this.setState({ bigpreviewMode: !bigpreviewMode });
        const buttons = document.querySelectorAll(".ant-table-row-expand-icon");
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].click();
        }
    };
    setConfig = (data) => {
        this.setState({ loadConfig: data });
    };
    hidePreloadingMask = () => {
        if (this.state.preloadingMask) this.setState({ preloadingMask: false });
    };
    setRole = (role) => {
        if (role !== "CLIENT") {
            this.setState({ internal: true });
            document.getElementsByTagName("body")[0].classList.add("internal");
            document
                .getElementsByTagName("body")[0]
                .setAttribute("data-role", "internal");
        } else {
            this.setState({ internal: false });
            document.getElementsByTagName("body")[0].classList.add("client");
            document
                .getElementsByTagName("body")[0]
                .setAttribute("data-role", "CLIENT");
        }
    };
    reviewButtonClicked = (val) => {
        this.setState({ reviewButtonClicked: val });
    };
    bookingLoaded = (val, e) => {
        this.setState({
            bookingLoaded: val,
            bookingLoadedErrorMessage: e.message,
        });
        if (!val) {
            console.log("load booking failed");
        }
    };
    downloadOrder = () => {
        const { loadBookingData } = this.state;
        fetch(urlPath + "/api/downloadad?ad=" + loadBookingData.ad.id, {
            credentials: "include",
            headers: getAuthHeader(),
        })
            .then((response) => response.text())
            .then((data) => {
                var win = window.open(data, "_blank");
                win.focus();
            })
            .catch((e) => console.log(e));
    };

    handleArchivedMenuClick = (e) => {
        const key = e.key;
        let archivedButtonText = null;
        const { translations } = this.state;
        /*let matspecArchived = document.getElementsByClassName('creative-archived-true')
    let matspecProduction = document.getElementsByClassName('creative-archived-false')
    matspecArchived = Array.from(matspecArchived);
    matspecProduction = Array.from(matspecProduction);*/
        if (key === "all") {
            this.setState({ showArchived: "d-block" });
            archivedButtonText = translations.all;
            //matspecProduction.length > 0 && matspecProduction.map(item => item.classList.remove('d-none'))
            //matspecArchived.length > 0 && matspecArchived.map(item => item.classList.remove('d-none'))
        }
        if (key === "archived") {
            this.setState({ showArchived: "show-archived" });
            archivedButtonText = translations.archived;
            //matspecArchived.length > 0 && matspecArchived.map(item => item.classList.remove('d-none'))
            //matspecProduction.length > 0 && matspecProduction.map(item => item.classList.add('d-none'))
        }
        if (key === "inproduction") {
            this.setState({ showArchived: "show-archived-false" });
            archivedButtonText = translations.inProduction;
            //matspecProduction.length > 0 && matspecProduction.map(item => item.classList.remove('d-none'))
            //matspecArchived.length > 0 && matspecArchived.map(item => item.classList.add('d-none'))
        }
        this.setState({ archivedButtonText });
    };

    handleMultiCheckedTypes = (checkedMatspecs) => {
        const { loadBookingData } = this.state;
        const { matspecs } = loadBookingData;
        let printedMatspecs = checkedMatspecs.map((_) =>
            matspecs.filter((matspec) => _ === matspec.id && matspec.printed)
        );
        let digitalMatspecs = checkedMatspecs.map((_) =>
            matspecs.filter((matspec) => _ === matspec.id && !matspec.printed)
        );
        printedMatspecs = printedMatspecs.filter((_) => _.length > 0).length;
        digitalMatspecs = digitalMatspecs.filter((_) => _.length > 0).length;
        //printedMatspecs = printedMatspecs.filter(_ => !isNaN(_))
        //console.log("printedMatspecs", printedMatspecs);
        //console.log("digitalMatspecs", digitalMatspecs);
        if (printedMatspecs > 0 && digitalMatspecs > 0) {
            this.setState({
                multiTypesChecked: true,
                printedMatspecs,
                digitalMatspecs,
            });
        } else {
            this.setState({
                multiTypesChecked: false,
                printedMatspecs,
                digitalMatspecs,
            });
        }
    };

    handleMultiChecked = (checkedMatspecs, e, type = null) => {
        let checkedMatspecsArray = [];
        if (type === "all") {
            const checked = e.target.checked;
            this.setState({ multiUploadChecked: checked });
            const { loadBookingData } = this.state;
            const { matspecs } = loadBookingData;
            checkedMatspecsArray = checked ? matspecs.map((_) => _.id) : [];
            this.setState({ checkedMatspecsArray });
            console.log(checkedMatspecsArray);
            this.handleMultiCheckedTypes(checkedMatspecsArray);
            return;
        }
        this.handleMultiCheckedTypes(checkedMatspecs);
        checkedMatspecsArray = checkedMatspecs.map((_) => parseInt(_, 10));
        this.setState({ checkedMatspecsArray });
    };
    setCheckedMatspecsArray = (arr) => {
        this.setState({ checkedMatspecsArray: arr })
        this.handleMultiCheckedTypes(arr)
    };
    refreshBooking = (val) => {
        this.setState({ shouldRefreshBooking: val });
        if (val) this.setState({ checkedMatspecsArray: [] });
        //setTimeout(() => window.location.reload(), 2000);
    };
    onKilledChange = (e) => {
        console.log("Switch change killed", e.target.checked);
        this.setState({ showKilled: e.target.checked }, () =>
            this.setState({ showKilled: e.target.checked })
        );
        console.log(this.state.showKilled);
    };


    render() {
        if (!this.state.loadBookingData)
            return (
                <PreloadingMask
                    visible={true}
                    text={
                        this.state.translations &&
                            this.state.translations.fetching
                            ? this.state.translations.fetching
                            : "..."
                    }
                />
            );
        const { translations } = this.state;
        const menu = (
            <Menu onClick={this.handleArchivedMenuClick}>
                <Menu.Item key="all">
                    {translations && translations.all}
                </Menu.Item>
                <Menu.Item key="archived">
                    {translations && translations.archived}
                </Menu.Item>
                <Menu.Item key="inproduction">
                    {translations && translations.inProduction}
                </Menu.Item>
            </Menu>
        );
        const materials = [
            <Matspec
                saveFields={this.saveFields}
                setCheckedMatspecsArray={this.setCheckedMatspecsArray}
                bigpreviewMode={this.state.bigpreviewMode}
                multiUploadChecked={this.state.multiUploadChecked}
                showOrHideByCreativeType={this.showOrHideByCreativeType}
                showKilled={this.state.showKilled}
                currentTabKey={this.state.currentTabKey}
                fieldTranslations={this.state.fieldTranslations}
                updateMatspec={this.updateMatspec}
                updateBooking={this.updateBooking}
                loadConfigVal={this.state.loadConfigVal}
                adBooking={this.state.adBooking}
                matspecsBooking={this.state.matspecsBooking}
                userBooking={this.state.userBooking}
                bookingLoaded={this.state.bookingLoaded}
                defaultActiveKey={this.state.defaultActiveKey}
                handleMultiChecked={this.handleMultiChecked}
                bookingLoaded={this.bookingLoaded}
                languageCode={this.state.languageCode}
                previewClick={this.previewClick}
                translations={this.state.translations}
                fieldConfig={this.state.fieldConfig}
                hidePreloadingMask={this.hidePreloadingMask}
                detailsVisible={this.state.detailsVisible}
                currentMatspecId={this.state.currentMatspecId}
                key={this.state.specId}
                loadBooking={this.loadBooking}
                language={this.state.language}
                highlightedMaterial={this.state.approveAdmaterialId}
                scrollY={this.state.scrollY}
                loadBookingData={this.state.loadBookingData}
                specId={this.state.specId}
                internal={this.state.internal}
                matspecNameParam={this.state.matspecNameParam}
                submitting={this.submitting}
                uploadFinished={this.uploadFinished}
                reviewButtonClicked={this.reviewButtonClicked}
                setRole={this.setRole}
                showModal={this.showModal}
                preflightReport={this.state.preflightReport}
                loadConfig={this.state.loadConfig}
                setConfig={this.setConfig}
                unsubmittedChanges={this.unsubmittedChanges}
                showArchived={this.state.showArchived}
                shouldRefreshBooking={this.state.shouldRefreshBooking}
                refreshBooking={this.refreshBooking}
                openedMatspec={this.state.openedMatspec}
                isNative={nativeDevParam}
                showExpandAll={true}
                singleAd={this.state.singleAd}
                checkedMatspecsArray={this.state.checkedMatspecsArray}
            />,
        ];

        /*if (window.screen.width < 769)
      return <Mobile translations={translations} />;
    else */ if (
            this.state.modeParam !== "details"
        ) {
            return (
                <div
                    className="App ix"
                    data-currenttabkey={this.state.currentTabKey}
                >
                    <PreloadingMask
                        loadBookingErrorMessage={
                            this.state.loadBookingErrorMessage
                        }
                        translations={this.state.translations}
                        visible={this.state.preloadingMask}
                        text={
                            this.state.translations &&
                                this.state.translations.loading
                                ? this.state.translations.loading
                                : "Loading"
                        }
                        fetched={true}
                    />
                    <ErrorPage
                        translations={this.state.translations}
                        bookingLoaded={this.state.bookingLoaded}
                        bookingLoadedErrorMessage={
                            this.state.bookingLoadedErrorMessage
                        }
                    />
                    {(devMode || !this.state.internal) &&
                        this.state.loadSplash &&
                        this.state.splashVisible && (
                            <Splash
                                languageCode={this.state.languageCode}
                                specId={this.state.specId}
                                onOk={this.closeSplash}
                                visible={this.state.splashVisible}
                                translations={this.state.translations}
                                url={this.state.splashFrame}
                                showCheckbox={this.props.config["web.campaign.enableSplashScreen"]}
                            />
                        )}
                    <Preloader
                        preflightingTxt={
                            this.state.translations
                                ? this.state.translations.preflightingTxt
                                : ""
                        }
                        language={this.state.language}
                        preloader={this.state.preloader}
                    />
                    {!this.state.tabbedView && this.state.loadHeader && (
                        <Header
                            clickHelp={this.clickHelp}
                            fieldConfig={this.state.fieldConfig}
                            matspec={this.state.matspec}
                            language={this.state.language}
                            handleLangCode={this.handleLangCode}
                            languageCode={this.state.languageCode}
                            headerFrameUrl={this.state.headerFrameUrl}
                            translations={this.state.translations}
                        />
                    )}
                    {!this.state.tabbedView && (
                        <iframe
                            id="campaignInfoFrame"
                            title="campaignInfoFrame"
                            src={this.state.campaignInfoFrame}
                        />
                    )}
                    <div
                        className={
                            this.state.detailsVisible
                                ? "d-none"
                                : "ix-container"
                        }
                    >
                        <div id="matspecFilterTabs">
                            <Menu
                                onClick={(e) => this.handleTabFilterClick(e)}
                                selectedKeys={[this.state.currentTabKey]}
                                mode="horizontal"
                            >
                                <Menu.Item key="all" id="menuItemAll">
                                    <Icon type="appstore" />
                                    {this.state.translations &&
                                        this.state.translations.all}
                                </Menu.Item>
                                {this.state.creativeTypes &&
                                    this.state.creativeTypes.map((item) => {
                                        const decoded = decodeURIComponent(item);
                                        return (
                                            <Menu.Item key={item} id="menuItemAll">
                                                {this.state.translations &&
                                                    this.state.translations[decoded]
                                                    ? this.state.translations[decoded]
                                                    : decoded}
                                            </Menu.Item>
                                        )
                                    })}
                            </Menu>
                            <div className="matspec--tabs--buttons">
                                {this.state.loadConfig &&
                                    this.state.loadConfig[
                                    "web.campaign.allMatspecsUpload"
                                    ] && (
                                        <React.Fragment>
                                            <React.Fragment>
                                            {this.state.checkedMatspecsArray.length > 0 &&
                                                !this.state.multiTypesChecked && (
                                                    <span>
                                                        <FileUpload
                                                            disabled={true}
                                                            admaterialUploaded={null}
                                                            admaterialUploading={null}
                                                            filePlaceholder={
                                                                translations &&
                                                                    translations.multiUpload
                                                                    ? translations.multiUpload
                                                                    : "Multi Upload"
                                                            }
                                                            language={null}
                                                            loadConfig={
                                                                this.state.loadConfig
                                                            }
                                                            materialSpecificationId={null}
                                                            printAd={
                                                                this.state.printedMatspecs
                                                                    ? "PRINTED"
                                                                    : "DIGITAL"
                                                            }
                                                            specId={null}
                                                            submitting={null}
                                                            translations={
                                                                translations && translations
                                                            }
                                                            checkedMatspecsArray={
                                                                this.state
                                                                    .checkedMatspecsArray
                                                            }
                                                            refreshBooking={
                                                                this.refreshBooking
                                                            }
                                                        />
                                                    </span>
                                                )}
                                                {this.state.multiTypesChecked && (
                                                    <React.Fragment>
                                                        {this.state.multiTypesChecked && (
                                                            <span style={{ display: 'inline-block', marginRight: "12px", color: "red" }}>
                                                                {this.state.translations &&
                                                                    this.state.translations
                                                                        .multiNotAllowed
                                                                    ? this.state
                                                                        .translations
                                                                        .multiNotAllowed
                                                                    : "Multi upload not Allowed"}
                                                            </span>
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </React.Fragment>
                                            <Checkbox
                                                onClick={(e) =>
                                                    this.handleMultiChecked(
                                                        [],
                                                        e,
                                                        "all"
                                                    )
                                                }
                                            >
                                                Select all matspecs
                                            </Checkbox>
                                        </React.Fragment>
                                    )}
                                {this.state.internal && (
                                    <Checkbox onChange={this.onKilledChange}>
                                        <span data-translationkey="showKilled">
                                            {translations &&
                                                translations.showKilled
                                                ? translations.showKilled
                                                : "Show killed"}
                                        </span>
                                    </Checkbox>
                                )}
                                <Dropdown overlay={menu}>
                                    <Button
                                        size="small"
                                        style={{ marginRight: "10px" }}
                                        id="toggleArchived"
                                    >
                                        {this.state.archivedButtonText
                                            ? this.state.archivedButtonText
                                            : translations &&
                                            translations.inProduction}{" "}
                                        <Icon type="down" />
                                    </Button>
                                </Dropdown>
                                <Button
                                    className="download-button"
                                    onClick={() => this.downloadOrder()}
                                    type="primary"
                                    size="small"
                                >
                                    {this.state.translations &&
                                        this.state.translations.downloadBooking}
                                </Button>
                                <Tooltip
                                    title={
                                        this.state.bigpreviewMode
                                            ? this.state.translations
                                                ? this.state.translations
                                                    .listView
                                                : "List view"
                                            : this.state.translations
                                                ? this.state.translations
                                                    .fullPreview
                                                : "Full preview"
                                    }
                                >
                                    <Button
                                        id="handleBigPreviewModeButton"
                                        style={{ marginLeft: "10px" }}
                                        size="small"
                                        onClick={this.handleBigPreviewMode}
                                    >
                                        {this.state.bigpreviewMode ? (
                                            <Icon type="unordered-list" />
                                        ) : (
                                                <Icon type="pic-center" />
                                            )}
                                    </Button>
                                </Tooltip>
                                <Button
                                    style={{ marginLeft: "10px" }}
                                    size="small"
                                    type="secondary"
                                    onClick={() => window.location.reload()}
                                >
                                    <Icon type="reload" />
                                </Button>
                            </div>
                        </div>
                        <h1 className="ix-title">Campaign</h1>
                        <Provider store={store}>
                            <BigBucket languageCode={this.state.languageCode} />
                        </Provider>
                        {materials}
                    </div>
                    {this.state.translations &&
                        this.state.loadDetails &&
                        this.state.changesButtons && (
                            <Details
                                saveFields={this.saveFields}
                                hasClickTag={this.state.hasClickTag}
                                tabbedView={this.state.tabbedView}
                                allowDownload={this.state.allowDownload}
                                approveAdmaterialId={
                                    this.state.approveAdmaterialId
                                }
                                assetToMaterial={this.assetToMaterial}
                                assetUpload={this.state.assetUpload}
                                assetView={this.state.assetView}
                                assetVisualId={this.state.assetVisualId}
                                changesButtons={this.state.changesButtons}
                                clickHelp={this.clickHelp}
                                closeModal={this.closeModal}
                                currentStatusCode={this.state.currentStatusCode}
                                defaultActiveTabReport={
                                    this.state.defaultActiveTabReport
                                }
                                editableView={this.state.editableView}
                                fieldConfig={this.state.fieldConfig}
                                hasMaterial={this.state.hasMaterial}
                                hasVisual={this.state.hasVisual}
                                handleResubmit={this.handleResubmit}
                                internal={this.state.internal}
                                langCode={this.handleLangCode}
                                language={this.state.language}
                                languageCode={this.state.languageCode}
                                loadConfig={this.state.loadConfig}
                                loadIframe={this.state.loadIframe}
                                loadBookingData={this.state.loadBookingData}
                                matspec={this.state.matspec}
                                matspecId={this.state.matspecId}
                                modalTitle={this.state.orderNumber}
                                newAssetIds={this.state.newAssetIds}
                                onOk={this.handleCancel}
                                handleAdMatRemoval={this.handleAdMatRemoval}
                                order={this.state.order}
                                orderno={this.state.orderno}
                                pageCount={this.state.pageCount}
                                pageCountMax={this.state.pageCountMax}
                                preflightReport={this.state.preflightReport}
                                previewClick={this.previewClick}
                                previewClickStatusCode={
                                    this.state.previewClickStatusCode
                                }
                                printed={this.state.printed}
                                productionad={this.state.productionad}
                                proofLink={this.state.proofLink}
                                reviewButtonClicked={
                                    this.state.reviewButtonClicked
                                }
                                showProductionAdButtons={
                                    this.state.showProductionAdButtons
                                }
                                showVideoControls={this.state.showVideoControls}
                                specId={this.state.currentMatSpecId}
                                translations={this.state.translations}
                                unsubmittedChangesValue={
                                    this.state.unsubmittedChangesValue
                                }
                                visible={this.state.detailsVisible}
                            />
                        )}
                    <Modal
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        preview={this.state.preview}
                        text={this.state.text}
                    />
                </div>
            );
        } else {
            document.getElementById("root").classList.add("detailsMode");
            document
                .getElementsByTagName("body")[0]
                .classList.add("detailsMode");
            document
                .getElementsByTagName("body")[0]
                .setAttribute("id", "detailsBody");
            return (
                <div className="App ix detailsMode">
                    {(devMode || !this.state.internal) &&
                        this.state.loadSplash &&
                        this.state.splashVisible && (
                            <Splash
                                specId={this.state.specId}
                                onOk={this.closeSplash}
                                visible={this.state.splashVisible}
                                translations={this.state.translations}
                                url={this.state.splashFrame}
                            />
                        )}
                    <Preloader
                        preflightingTxt={
                            this.state.translations
                                ? this.state.translations.preflightingTxt
                                : ""
                        }
                        language={this.state.language}
                        preloader={this.state.preloader}
                    />
                    {!this.state.tabbedView && this.state.loadHeader && (
                        <Header
                            clickHelp={this.clickHelp}
                            fieldConfig={this.state.fieldConfig}
                            matspec={this.state.matspec}
                            language={this.state.language}
                            langCode={this.handleLangCode}
                            languageCode={this.state.languageCode}
                            headerFrameUrl={this.state.headerFrameUrl}
                            translations={this.state.translations}
                        />
                    )}
                    {!this.state.tabbedView && (
                        <iframe
                            id="campaignInfoFrame"
                            title="campaignInfoFrame"
                            src={this.state.campaignInfoFrame}
                        />
                    )}
                    <div className="d-none">
                        <h1 className="ix-title">Campaign</h1>
                        {materials}
                    </div>
                    {this.state.translations &&
                        this.state.loadDetails &&
                        this.state.changesButtons && (
                            <Details

                                saveFields={this.saveFields}
                                hasClickTag={this.state.hasClickTag}
                                tabbedView={this.state.tabbedView}
                                allowDownload={this.state.allowDownload}
                                showVideoControls={this.state.showVideoControls}
                                approveAdmaterialId={
                                    this.state.approveAdmaterialId
                                }
                                assetToMaterial={this.assetToMaterial}
                                assetUpload={this.state.assetUpload}
                                assetView={this.state.assetView}
                                assetVisualId={this.state.assetVisualId}
                                changesButtons={this.state.changesButtons}
                                clickHelp={this.clickHelp}
                                currentStatusCode={this.state.currentStatusCode}
                                defaultActiveTabReport={
                                    this.state.defaultActiveTabReport
                                }
                                editableView={this.state.editableView}
                                fieldConfig={this.state.fieldConfig}
                                hasMaterial={this.state.hasMaterial}
                                hasVisual={this.state.hasVisual}
                                handleResubmit={this.handleResubmit}
                                internal={this.state.internal}
                                langCode={this.handleLangCode}
                                language={this.state.language}
                                languageCode={this.state.languageCode}
                                loadConfig={this.state.loadConfig}
                                loadIframe={this.state.loadIframe}
                                loadBookingData={this.state.loadBookingData}
                                matspec={this.state.matspec}
                                order={this.state.order}
                                matspecId={this.state.matspecId}
                                modalTitle={this.state.orderNumber}
                                newAssetIds={this.state.newAssetIds}
                                onOk={this.handleCancel}
                                handleAdMatRemoval={this.handleAdMatRemoval}
                                pageCount={this.state.pageCount}
                                pageCountMax={this.state.pageCountMax}
                                preflightReport={this.state.preflightReport}
                                previewClick={this.previewClick}
                                previewClickStatusCode={
                                    this.state.previewClickStatusCode
                                }
                                printed={this.state.printed}
                                productionad={this.state.productionad}
                                proofLink={this.state.proofLink}
                                reviewButtonClicked={
                                    this.state.reviewButtonClicked
                                }
                                specId={this.state.specId}
                                translations={this.state.translations}
                                unsubmittedChangesValue={
                                    this.state.unsubmittedChangesValue
                                }
                                visible={true}
                                orderno={this.state.orderno}
                                showProductionAdButtons={
                                    this.state.showProductionAdButtons
                                }
                            />
                        )}
                    <Modal
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        preview={this.state.preview}
                        text={this.state.text}
                    />
                </div>
            );
        }
    }
    componentWillMount() {
        const { internal } = this.props;
        console.log("internal", internal);
        this.setState({ loadConfigVal: this.props.config });
        var urlParams = new URLSearchParams(window.location.search);
        const dataParam = urlParams.get("data");
        const matspecParam = urlParams.get("matspec");
        let loadbookingUrl = null;
        if (dataParam)
            loadbookingUrl = urlPath + "/api/noauth/loadbooking?data=" + dataParam;
        else if (this.state.matspecNameParam) {
            const systemidParam = urlParams.get("systemid");
            loadbookingUrl = urlPath + "/api/loadbooking_matspecname?matspec=" + this.state.matspecNameParam + (systemidParam ? "&systemid=" + systemidParam : "");
        } else if (matspecParam)
            loadbookingUrl = urlPath + "/api/loadbooking?matspec=" + matspecParam;
        if (!loadbookingUrl)
            return;

        let bookingHasErrored = false;
        if (!this.state.loadBookingData)
            fetch(loadbookingUrl + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone, dataParam ? {} : { credentials: "include", headers: getAuthHeader() })
                .then((response) => {
                    if (!response.ok) bookingHasErrored = true;
                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    //data.matspecs = []; // for testing purposes only
                    setData(data);
                    if (bookingHasErrored) throw Error(data.error);
                    else this.loadBooking.call(this, data);
                })
                .catch((e) => {
                    console.error("Cannot load booking: ", e);
                    this.bookingLoaded(false, e);
                });

        //if (!this.state.loadBookingData) return null;
        const setData = (data) => {
            let partyTagSmallDropzoneLabel =
                this.state.translations &&
                this.state.translations.partyTagSmallDropzoneLabel;
            if (
                partyTagSmallDropzoneLabel &&
                partyTagSmallDropzoneLabel.length > 0
            ) {
                this.setState({ partyTagSmallDropzoneLabel: true });
            }
            if (data.matspecs && data.matspecs.length < 1) {
                alert(
                    this.state.translations.error +
                    ": " +
                    this.state.translations.matspecEmpty
                );
                /*Modal.error({
		title: this.state.translations.error,
		content: this.state.translations.matspecEmpty,
		onOk: () => console.log("closing"),
		onCancel: () => console.log("closing")
	  });*/
                return null;
            }
            const defaultActiveKeys = [];
            const matspecsOrdered = data.matspecs;
            const currentMaterialSpecification =
                data.currentMaterialSpecification;
            this.setState({
                currentMaterialSpecification: currentMaterialSpecification,
            });
            if (data.AuthorizationToken) {
                setAuthHeader({
                    Authorization: "Basic " + data.AuthorizationToken,
                });
                delete data.AuthorizationToken;
            }
            if (data.user) {
                setUser(data.user);
                this.setRole(data.user.rol_enum);
            }
            if (data.ad) {
                document
                    .getElementsByTagName("body")[0]
                    .setAttribute("data-systemid", data.ad.systemid);
            }
            const activeMatspecs = sessionStorage.getItem("activeMatspecs");
            console.log("activeMatspecs", activeMatspecs);
            for (let i = 0; i < matspecsOrdered.length; i++) {
                if (!matspecsOrdered[i].productionad)
                    matspecsOrdered[i].visualassetid = 0;
                const currentMatspec = matspecsOrdered[i];
                if (currentMatspec.id === currentMaterialSpecification)
                    defaultActiveKeys.push(currentMatspec.id.toString());
                if (
                    activeMatspecs &&
                    activeMatspecs.includes(currentMatspec.id.toString())
                )
                    defaultActiveKeys.push(currentMatspec.id.toString());
                if (!currentMatspec.admaterial)
                    currentMatspec.admaterial = [];
            }
            console.log("defaultActiveKeys", defaultActiveKeys);
            this.setState({
                adBooking: data.ad,
                matspecsBooking: matspecsOrdered,
                userBooking: data.user,
                bookingLoaded: true,
                defaultActiveKey: defaultActiveKeys,
                showKilled: false,
            });
        };
    }
    updateMatspec = (data) => {
        this.setState({ matspecsBooking: data });
    };
    componentDidMount() {
        var url =
            window.location != window.parent.location
                ? document.referrer
                : document.location.href;
        const tabbedView = url.includes("TabbedView");
        this.setState({ tabbedView });
        this.setLang(this.state.languageCode);
    }
    saveFields = () => {
        const { fieldsToSave } = this.props;
        console.log("filtered", fieldsToSave);
        console.log(this.state.specId)
        //fieldsToSave.map((_) => admaterialUpdateHelper(_));
        admaterialUpdateHelper(fieldsToSave)
        this.props.setFieldsToSave([])
    };
    componentDidUpdate(prevProps, nextProps) {

        //console.log("component did update");

        //this.saveFields();
        this.showOrHideByCreativeType(this.state.currentTabKey);
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);


// WEBPACK FOOTER //
// ./src/components/App.js